<template>
  <div class="page403">
    <div class="error-card glass">
      <div class="avatar-wrap">
        <img src="../../assets/403.webp" alt="403" class="emoji-img" />
      </div>
      <div class="dash"></div>
      <h1 class="code">403</h1>
      <p class="tip">抱歉，你没有访问该页面的权限</p>
      <button class="home-btn" @click="router.push('/')">返回首页</button>
    </div>
  </div>
</template>

<script setup>
import {useRouter} from "vue-router";
const router = useRouter();
</script>

<style scoped>
.page403 {
  min-height: 72vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.error-card {
  width: 100%;
  max-width: 640px;
  padding: 64px 48px;
  border-radius: 28px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  text-align: center;
}

.avatar-wrap {
  margin-bottom: 24px;
}

.emoji-img {
  width: 160px;
  height: 160px;
  object-fit: contain;
}

.dash {
  width: 36px;
  height: 3px;
  background-color: var(--laputa-common-font-color);
  margin: 0 auto 32px;
  border-radius: 2px;
}

.code {
  font-size: 72px;
  font-weight: 600;
  color: var(--laputa-common-font-color);
  margin: 0 0 16px;
  line-height: 1;
}

.tip {
  font-size: 18px;
  color: var(--laputa-common-secondary-font-color);
  margin: 0 0 40px;
}

.home-btn {
  padding: 13px 36px;
  font-size: var(--laputa-fontsize-15);
  border-radius: 999px;
  border: none;
  cursor: pointer;
  transition: all 0.22s ease;
  background-color: var(--laputa-svg-color);
  color: var(--laputa-common-inverse-font-color);
}

.home-btn:hover {
  background: var(--laputa-primary);
  color: var(--laputa-white);
}


@media (max-width: 600px) {
  .error-card {
    padding: 48px 24px;
  }
  .emoji-img {
    width: 130px;
    height:130px;
  }
  .code {
    font-size: 56px;
  }
}
</style>